import React, {Component} from "react";
import { translate } from "react-translate"
import { Segment, Button, Icon } from "semantic-ui-react";


class CommandPanel extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {hide, handleAddMaterial, handleAddWorkforce, handleAddWork, handleAddCategory, handleAddSubcategory, handleAddPageJump, handleAddNote} = this.props;
        var {hasCategory} = this.props;
        if(hide){
            return (<div/>);
        }
        if(!hasCategory) {
            hasCategory = () => false;
        }
        return (
            <div id="commandPanelWrapper">
                <Segment className="cmdSegment">
                    <span className="cmdLabel">Ajouter une ligne :</span> 
                    <Button onClick={() => handleAddMaterial()}>
                        <Icon name="euro"></Icon>
                        matériau
                    </Button>
                    <Button onClick={() => handleAddWorkforce()}>                    
                        <Icon name="euro"></Icon>
                        main d'oeuvre
                    </Button>
                    <Button onClick={() => handleAddWork()}>                    
                        <Icon name="euro"></Icon>
                        ouvrage
                    </Button>
                </Segment>
                <Segment className="cmdSegment">
                    <span className="cmdLabel">Ajouter un élément : </span>
                    <Button onClick={() => handleAddCategory()}>                    
                        <Icon name="table"></Icon>
                        catégorie
                    </Button>
                    {
                        hasCategory() ? (
                            <Button onClick={() => handleAddSubcategory()}>                    
                                <Icon name="columns"></Icon>
                                sous-catégorie
                            </Button>
                        ) : null
                    }
                    <Button onClick={() => handleAddPageJump()}>                    
                        <Icon name="sticky note outline"></Icon>
                        saut de page
                    </Button>
                    <Button onClick={() => handleAddNote()}>                    
                        <Icon name="edit"></Icon>
                        note
                    </Button>
                </Segment>
            </div>
        );
    }
}

export default translate("ProEditDevisCommandPanel")(CommandPanel);


// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/CommandPanel.jsx